import React from 'react';
import { Button, Form, Offcanvas } from "react-bootstrap";
import MultiSelect from '../../components/MultiSelect';

const IdentityFilter = ({ show, close }) => {
    return (
        <>
            <Offcanvas show={show} onHide={close} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        Identity Filter
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        {/* <Form.Group className="mb-3">
                            <Form.Label>League:</Form.Label>
                            <Form.Select>
                                <option value="">League 1</option>
                                <option value="">League 2</option>
                                <option value="">League 3</option>
                            </Form.Select>
                        </Form.Group> */}

                        <Form.Group className="mb-3">
                            <Form.Label>Name:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Name" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email:</Form.Label>
                            <Form.Control type="email" placeholder="Search by Email" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Account History:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Account History" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Phone Number:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Phone Number" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Address:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Address" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>City:</Form.Label>
                            <Form.Control type="text" placeholder="Search by City" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>State:</Form.Label>
                            <Form.Control type="text" placeholder="Search by State" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Zip Code:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Zip Code" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Metro Area:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Metro Area" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Real / Fake:</Form.Label>
                            <Form.Control type="text" placeholder="Search by Real / Fake" />
                        </Form.Group>


                    </Form>
                </Offcanvas.Body>
                <Offcanvas.Header>
                    <div className="col-6">
                        <Button variant="primary" className="text-white w-100 fw-bold">
                            Reset
                        </Button>
                    </div>
                    <div className="col-6">
                        <Button variant="primary" onClick={close} className="text-white w-100 fw-bold">
                            Filter
                        </Button>
                    </div>
                </Offcanvas.Header>
            </Offcanvas>
        </>
    );
};

export default IdentityFilter;